import LatestUpdatesResponse from '@Types/api/strapi/LatestUpdatesResponse';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevrone-down.svg';
import CarouselItem from './components/CarouselItem';

import commonStyle from '../../common-mobile-styles.module.css';
import styles from './component-styles.module.css';

interface LatestUpdatesMobileProps {
  latestUpdates: LatestUpdatesResponse | undefined;
}

const LatestUpdatesMobile: React.FC<LatestUpdatesMobileProps> = ({
  latestUpdates,
}) => {
  return (
    <>
      <div className={commonStyle.header}>
        <div className={commonStyle.caption}>Latest Updates</div>
        <div className={commonStyle.link}>
          <ChevroneIcon className={commonStyle.chevrone} />
        </div>
      </div>
      {latestUpdates?.data.length && (
        <div className={styles.shorterPostContent}>
          {latestUpdates?.data.map((news) => (
            <CarouselItem
              key={news.id}
              publishedAt={news.attributes.publishedAt}
              description={news.attributes.newsPostDescription}
              imageSrc={
                news.attributes.newsPostImage.data[0].attributes.formats
                  .thumbnail.url
              }
              newsType={news.attributes.newsType}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default LatestUpdatesMobile;
